import { generatePkceSet } from "./helpers/auth.helper.js";
import { CONSTANTS } from "./helpers/constants.js";
import { setLocalStorageItem } from "./helpers/token.service.js";

//#region src/initiate-auth-flow.ts
let Flow = /* @__PURE__ */ function(Flow$1) {
	Flow$1[Flow$1["Deeplink"] = 1] = "Deeplink";
	Flow$1[Flow$1["Employer"] = 2] = "Employer";
	Flow$1[Flow$1["CreateAccount"] = 3] = "CreateAccount";
	Flow$1[Flow$1["SignIn"] = 4] = "SignIn";
	Flow$1[Flow$1["UpdateProfile"] = 5] = "UpdateProfile";
	return Flow$1;
}({});
const initiateLoginChallenge = async ({ context, currentUrl, flow, employer, mustReauthenticate = false, ssoUrl, ssoClientId, redirectUri }) => {
	const { challenge, codeVerifier } = await generatePkceSet();
	const stateKey = CONSTANTS.csrfProtectionState;
	const stateValue = {
		...context && { context },
		...employer && { employer },
		flow,
		currentUrl,
		codeVerifier,
		state: stateKey,
		mustReauthenticate
	};
	const payload = window.btoa(JSON.stringify(stateValue));
	setLocalStorageItem(stateKey, payload);
	setLocalStorageItem(`${stateKey}${CONSTANTS.pkceCodeVerifierPrefix}`, codeVerifier);
	window.location.replace(new URL(`${ssoUrl}?client_id=${ssoClientId}&redirect_uri=${redirectUri}&response_type=code&state=${payload}&code_challenge_method=S256&code_challenge=${challenge}`));
};

//#endregion
export { Flow, initiateLoginChallenge };